import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
const _excluded = ["children", "className", "selectProps", "getStyles"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { AutoSizer, List } from 'react-virtualized';
import { SuggestBoxContext } from './Context';
const ContainerDiv = styled.div.withConfig({
  displayName: "MenuList__ContainerDiv",
  componentId: "sc-15bb2z4-0"
})(["min-width:fit-content;&& > div{width:unset !important;}"]);
const baseList = [];

function createRowRenderer(children, getCurrentIndex, childRef) {
  const newProps = {
    innerRef: childRef
  };
  return ({
    key,
    style,
    index
  }) => /*#__PURE__*/React.createElement("div", {
    key: key,
    style: _objectSpread(_objectSpread({}, style), {}, {
      // whiteSpace: 'pre',
      position: 'absolute',
      width: '100%'
    })
  }, index === getCurrentIndex() && children[index] ? /*#__PURE__*/React.cloneElement(children[index], newProps) : children[index]);
}

const getHeight = (calcHeight, maxHeight, minHeight) => Math.max(Math.min(calcHeight, maxHeight), minHeight);
/** exporting for testing purposes only */


export const getWidth = (minWidth, width) => minWidth > width ? minWidth : width;
/** exporting for testing purposes only */

export const validIndexFallback = (current, fallback = 0) => current > -1 ? current : fallback;
export const MenuList = _ref => {
  let {
    children,
    className,
    selectProps,
    getStyles
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  if (!selectProps.noMaxHeight) {
    // this is for orders
    props.maxHeight = 110;
  }

  const [height, setHeight] = useState(0);
  const [minWidth, setMinWidth] = useState(0);
  const {
    getFocusedIndex,
    setMenuListRef,
    setRowHeight,
    selectedRowIndex,
    rowHeight
  } = useContext(SuggestBoxContext);
  const rowIndex = getFocusedIndex();
  const list = Array.isArray(children) ? children : baseList; // typescript says these may be undefined. Not sure how, so...

  /* istanbul ignore next */

  const {
    maxMenuHeight = 0,
    minMenuHeight = 0
  } = selectProps;
  const ListRef = useRef(null);
  const firstChildRef = useCallback(node => {
    if (node !== null) {
      node.style.setProperty('width', 'fit-content');
      const {
        height: newRowHeight,
        width: newMinWidth
      } = node.getBoundingClientRect();
      node.style.removeProperty('width');

      if (minWidth !== newMinWidth) {
        setMinWidth(newMinWidth);
      }

      if (rowHeight !== newRowHeight) {
        setRowHeight(newRowHeight);
      }
    }
  }, [setMinWidth, setRowHeight, minWidth, rowHeight]);

  const getCurrentIndex = () => {
    let selectedIndex = 0;

    if (props.hasValue) {
      const selected = props.getValue();
      const currentSelectedIndex = props.options.indexOf(selected === null || selected === void 0 ? void 0 : selected[0]);
      selectedIndex = validIndexFallback(currentSelectedIndex, selectedIndex);
    }

    return selectedIndex;
  };

  const rowRenderer = createRowRenderer(list, getCurrentIndex, firstChildRef);
  useEffect(() => {
    setMenuListRef(ListRef);
  }, [setMenuListRef]);
  useEffect(() => {
    const calcHeight = list.length * rowHeight + 8;
    const newHeight = getHeight(calcHeight, maxMenuHeight, // I have no idea how to make calcHeight hit zero.

    /* istanbul ignore next */
    calcHeight > 0 ? Math.min(calcHeight, minMenuHeight) : minMenuHeight);
    setHeight(newHeight);
  }, [rowHeight, list.length, maxMenuHeight, minMenuHeight]);
  return /*#__PURE__*/React.createElement(ContainerDiv, {
    "data-testid": "menu-list-comp"
  }, list.length ? /*#__PURE__*/React.createElement(AutoSizer, {
    "data-testid": "sizer",
    disableHeight: true
  }, ({
    width
  }) => /*#__PURE__*/React.createElement(List, {
    role: "tablist",
    overscanRowCount: 20,
    ref: element => {
      if (!!element && typeof props.innerRef === 'function') {
        var _element$Grid;

        props.innerRef(element === null || element === void 0 ? void 0 : (_element$Grid = element.Grid) === null || _element$Grid === void 0 ? void 0 : _element$Grid._scrollingContainer.firstElementChild);
      }

      ListRef.current = element;
      return element;
    },
    scrollToRow: selectedRowIndex,
    scrollToIndex: rowIndex,
    style: _objectSpread({}, getStyles('menuList', props)),
    containerStyle: {
      width: '100%',
      maxWidth: '100%'
    },
    height: height,
    rowRenderer: rowRenderer,
    rowCount: list.length // width={getWidth(minWidth, width)}
    ,
    width: width // todo issue with minWidth
    ,
    rowHeight: rowHeight
  })) : children);
};